
<form name="dataCollectionForm" class="data-collection-form Marginbox__l-medium results-pane" autocomplete="off" (ngSubmit)="submit()">
  <!--<ng-container *ngIf="formsConfig">-->
  <div *ngFor="let formConfig of formsConfig;" class="data-form-content Flexbox ">
      <span class="Flexbox Flexbox__direction-rows results-pane" style="flex: 1 0 auto;width: 75%">
      <gen-dynamic-form class="info-dynamic-form"
                        [formName]="formConfig.formId"
                        [title]="formConfig.title"
                        [subTitle]="formConfig.subTitle"
                        [disabled]="false"
                        [formData]="formConfig.key ? currentTest[formConfig.key] : currentTest"
                        [formVertical]="formConfig.direction && formConfig.direction === 'vertical' ? true : false"
                        (formChange)="formChanged($event.form, $event.updated)"
                        (formInit)="formInit($event)"
                        [submitted]="submitted"
                        [submitButtonText]="formConfig.submitButton.needed ? formConfig.submitButton.title: ''"
                        (submitEmitter)="submitForm($event)"
                        [cancelButtonText]="formConfig.cancelButton.needed ? formConfig.cancelButton.title: ''"
                        (cancelEmitter)="cancelForm($event)"
         >
      </gen-dynamic-form>
    </span>
  </div>
  <!--</ng-container>-->
  <div class="dynamic-form-buttons-wrapper submit-button" style="float:right">
      <input type="submit" id="data-collection-form-submit-button"
             class="btn submitButton" value="Submit"
             ng-click="submitted = true"/>
  </div>
</form>
